import { Company } from './company';
import { Moment } from 'moment';

export class ParameterInsert {
    key: string;
    name: string;
    value: string;
}